import { FormattedMessage } from 'react-intl'

import { cases } from '@subaio/utils'

import type { Step, StepType } from 'containers/Flow/Step'
import { UserType } from 'containers/Flow/stepHandler'

import { HeaderIconSent } from 'components/Icons'
import { Card } from 'components/Layout'

import { IconContainer } from '../IconContainer'
import { Wrapper } from '../Wrapper'

type Props = TaggedType<Step, StepType.Success>

export const Success = ({ userMetadata: { advisorName, applicantName, userType } }: Props) => (
	<Wrapper>
		<Card>
			<IconContainer>
				<h1>
					<FormattedMessage id='flow.success.title' defaultMessage='Thank you' />
				</h1>
				<HeaderIconSent />
				<p>
					{cases(userType, {
						[UserType.Default]: (
							<FormattedMessage
								id='flow.success.description'
								defaultMessage='Your budget has been sent to {advisorName} who will review it and get back to you.'
								values={{ advisorName }}
							/>
						),
						[UserType.PrimaryWithCoapplicant]: (
							<FormattedMessage
								id='flow.success.descriptionWithCoapplicant'
								defaultMessage='Your budget has been sent to {advisorName} who will review it and get back to you. '
								values={{ advisorName }}
							/>
						),
						[UserType.Coapplicant]: (
							<FormattedMessage
								id='flow.success.descriptionCoapplicant'
								defaultMessage='Your information has been sent to {applicantName} and will be included in the budget that you will finalize together with {applicantName}.'
								values={{ applicantName }}
							/>
						),
					})}
				</p>
			</IconContainer>
		</Card>
	</Wrapper>
)
